/* eslint-disable max-len */
import React from 'react'
import TopHeader from '../../../components/TopHeader'
import CustomOverLay from '../../../components/CustomOverLay'
import { motion } from 'framer-motion'
import Loader from '../../../components/Loader'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { logout } from '../../auth/authSlice'
import { useDispatch ,useSelector} from 'react-redux'
import { useContext } from 'react'
import { useState } from 'react'
import GlobalContext from '../../../components/Context/GloablContext'
import { passwordCriteria } from '../../auth/LoginForm/Components/passwordCriteria'
import ErrorMessage from '../../../components/ErrorMessage'
import { dataService } from '../../../services/data.services'
import { handleClear } from '../../../redux/commonSlice'
import { userService } from '../../../services/user.services'
export default function UpdatePassword() {
    const [loading, setloading] = useState(false);
    const dispatch=useDispatch()
    
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage } = useContext(GlobalContext)

    const [type, settype] = useState({
        old_password: false,
        new_password: false,
        confirm_new_password:false
    })
    const navigate=useNavigate()
    const [updateData, setUpdateData] = useState({
        old_password: '',
        new_password: '',
        confirm_new_password: '',
    });
    const handleInputChange = (key, value) => {
        setUpdateData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };
    const [Overallerror,setOverallerror]=useState({
        "dependant_error1":false,
        "dependant_error2":false,
        "temp_pass":'',
        "new_pass":'',
        "confirm_new_pass":''
    })
    const [submitSelected,setSubmitSelected] = useState(false)

    const handleShowPassword = (id) => {
        settype((prev)=>({
            ...prev,
            [id]:!type[id]
        }));   
    }

    const handleUpdatePassword=async(e)=>{
        e.preventDefault();
        setSubmitSelected(true)
        setloading(true)
        
        if(updateData.old_password.trim()===updateData.new_password.trim()){
            setOverallerror((prev)=>({...prev,dependant_error1:true,dependant_error2:false,temp_pass:'',new_pass:'Current and new password cannot be same'}))
            setloading(false)
            return
    
        }
        if(updateData.new_password.trim()!==updateData.confirm_new_password.trim()){
            setOverallerror((prev)=>({...prev,dependant_error2:true,dependant_error1:false,confirm_new_pass:'Passwords do not match',new_pass:''}))
            setloading(false)
            return
        }
        const payload={
            "old_password": updateData.old_password,
            "new_password": updateData.new_password,
            "confirm_password": updateData.confirm_new_password,
            "type":"update"
        }
        const email = sessionStorage.getItem('email').toLowerCase()
        try{
            const response = await dataService.PatchAPI(payload,`users/reset-password/${email}`)
            if(!response?.error){
                const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
                dispatch(handleClear())
                await userService.logout()
                dispatch(logout())
                localStorage.setItem('arcm_trust_browser_token', browserIdValue);
                setToastmessage('Password updated successfully');
                navigate('/')
                
            }

        }catch(err){
            setOverallerror((prev)=>({...prev,dependant_error2:false,dependant_error1:false,temp_pass:err?.response?.data?.message}))
            setloading(false)
        }
       
        

    }
    const isPasswordValid = Object.values(passwordCriteria).every((criteria) => {
        return criteria.regex.test(updateData?.new_password);
    });

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Update Password"}/>
                {/* {isFetching&&status!=="fulfilled"?<CustomOverLay Active text="Loading Admin/Corporate Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:<> */}

                <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                    <motion.div 
                        className="mt-1"
                        animate={{ x: 0 }}
                        initial={{ x: -10 }}
                        transition={{duration:0.5}}
                    >
                        <div className='bg-white'>
                            <div className='flex items-center mb-5'>
                                <Link to={"/profile"}>
                                    <h1 className="text-sm font-normal text-[#52555D]">Profile</h1>
                                </Link>
                                <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                <h1 className="text-sm font-normal text-[#008586]">Update Password</h1>
                            </div>
                            <div className="flex items-center mb-2.5">
                                <Link to={"/profile"} className='flex items-center min-w-max z-[2]'>
                                    <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                    <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Profile</span>
                                </Link>
                                <h1 className='text-xl font-normal text-[#000000] text-center w-full ml-[-145px]'>
                                    Update Your Password
                                </h1>
                            </div>
                            <div className="2xl:w-[60%] xl:w-[80%] w-[90%] mx-auto mt-[37px] h-customh5 overflow-auto scrollBar-hidden">
                                <div className="flex border border-[#C5C9DA] rounded py-[15px]">
                                    <div className="w-1/2">
                                        <div className="w-full border-r border-[#CCE7E7] pt-2.5 xl:pr-[89px] xl:pl-[58px] px-10">
                                            <form action=""     onSubmit={(e)=>handleUpdatePassword(e)}
                                            >
                                                <div className='flex flex-col mb-4'>
                                                    <label htmlFor='old_password' className='text-xs font-semibold text-[#000] pb-1.5'>Current Password*</label>
                                                    <div className='relative'>
                                                        <input
                                                            type={type['old_password'] ? "text" : "password"}
                                                            id='old_password'
                                                            onFocus={()=>{
                                                                setOverallerror((prev)=>({
                                                                    ...prev,
                                                                    dependant_error1:false,
                                                                    dependant_error2:false,
                                                                    temp_pass:'',
                                                                    new_pass:'',
                                                                    confirm_new_pass:''
                                                                }))
                                                                setSubmitSelected(false)
                                                                
                                                            }} 
                                                            style={{border:`1px solid ${submitSelected&&(Overallerror.temp_pass!==''||Overallerror.dependant_error1&&Overallerror.new_pass!=='')?'#C81720':'#C5C9DA'}`}}
                                                            value={updateData.old_password}
                                                            onChange={(e)=>handleInputChange('old_password',(e.target.value).trim())}
                                                            className={`border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none`}
                                                            autoComplete='off'
                                                            placeholder='Enter current password'
                                                        />
                                                        <button onClick={() =>handleShowPassword('old_password')} type='button' className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                                            <span  className='text-xs font-semibold text-[#008586]'>
                                                                {type['old_password'] ? "HIDE" : "SHOW"}
                                                            </span>
                                                            <span className='text-xs font-semibold text-[#008586] hidden'>HIDE</span>
                                                        </button>
                                                    </div>
                                                    {Overallerror.temp_pass!=='' && <ErrorMessage error  message={Overallerror.temp_pass}/>}
                                                </div>
                                               
                                                <div className='flex flex-col mb-4'>
                                                    <label htmlFor='new_password' className='text-xs font-semibold text-[#000] pb-1.5'>New Password*</label>
                                                    <div className='relative'>
                                                        <input 
                                                            type={type['new_password'] ? "text" : "password"}
                                                            id='new_password'
                                                            value={updateData.new_password}
                                                            onFocus={()=>{
                                                                setOverallerror((prev)=>({
                                                                    ...prev,
                                                                    dependant_error1:false,
                                                                    dependant_error2:false,
                                                                    temp_pass:'',
                                                                    new_pass:'',
                                                                    confirm_new_pass:''
                                                                }))
                                                                setSubmitSelected(false)
                                                            }} 
                                                            style={{border:`1px solid ${submitSelected&&(Overallerror.new_pass!==''||(Overallerror.dependant_error2&&Overallerror.confirm_new_pass)||Overallerror.dependant_error1)?'#C81720':'#C5C9DA'}`}}
                                                            onChange={(e)=>handleInputChange('new_password',(e.target.value).trim())}
                                                            className={`border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none`}
                                                            autoComplete='off' placeholder='Enter new password' />
                                                        <button onClick={() =>handleShowPassword("new_password")} type='button' className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                                            <span  className='text-xs font-semibold text-[#008586]'>
                                                                {type['new_password'] ? "HIDE" : "SHOW"}
                                                            </span>
                                                            <span className='text-xs font-semibold text-[#008586] hidden'>HIDE</span>
                                                        </button>
                                                    </div>                                               

                                                    {Overallerror.new_pass!=='' && <ErrorMessage error  message={Overallerror.new_pass}/>}
                                                </div>
                                                <div className='flex flex-col'>
                                                    <label htmlFor='confirm_new_password' className='text-xs font-semibold text-[#000] pb-1.5'>Confirm New Password*</label>
                                                    <div className='relative'>
                                                        <input 
                                                            type={type['confirm_new_password'] ? "text" : "password"} id='confirm_new_password' 
                                                            value={updateData.confirm_new_password}
                                                            onFocus={()=>{
                                                                setOverallerror((prev)=>({
                                                                    ...prev,
                                                                    dependant_error1:false,
                                                                    dependant_error2:false,
                                                                    temp_pass:'',
                                                                    new_pass:'',
                                                                    confirm_new_pass:''
                                                                }))
                                                                setSubmitSelected(false)
                                                            }} 
                                                            autoComplete='off'
                                                            style={{border:`1px solid ${submitSelected&&(Overallerror.confirm_new_pass!==''||(Overallerror.dependant_error2&&Overallerror.confirm_new_pass!==""))?'#C81720':'#C5C9DA'}`}}
                                                            onChange={(e)=>handleInputChange('confirm_new_password',(e.target.value).trim())}
                                                            className={`border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none`}
                                                            placeholder='Enter new password'
                                                        />
                                                        <button onClick={() =>handleShowPassword('confirm_new_password')} type='button' className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                                            <span  className='text-xs font-semibold text-[#008586]'>
                                                                {type['confirm_new_password'] ? "HIDE" : "SHOW"}
                                                            </span>
                                                            <span className='text-xs font-semibold text-[#008586] hidden'>HIDE</span>
                                                        </button>
                                                    </div>
                                                    {Overallerror.confirm_new_pass!=='' && <ErrorMessage error  message={Overallerror.confirm_new_pass}/>}
                                                </div>
                                                
                                                <button type='submit'
                                                    id="login"
                                                    disabled={loading||!isPasswordValid||Object.values(updateData).some(value => typeof value === 'string' && value.trim() === '')}
                                                    className={`w-full mt-11 py-2.5 px-2 text-lg font-semibold text-[#fff] rounded-[16px] 
                                                        ${loading||!isPasswordValid||Object.values(updateData).some(value => typeof value === 'string' && value.trim() === '')?'bg-[#777C88]':'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50]'}`}>
                                                    {!loading?'Update':<span>{<Loader/>}</span>}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="w-1/2">
                                        <div className="w-full pt-2.5 xl:pl-[89px] xl:pr-[58px] px-10">
                                            <div className="px-[5px]">
                                                <p className="text-base font-semibold text-[#000000] pb-6">Password must have :</p>
                                                <ul >
                                                    {Object.keys(passwordCriteria).map((criteria,index)=>(
                                                        <li className={`flex  pb-4`} key={criteria}>
                                                            <span className='pt-1'>
                                                                <img src={(updateData.new_password==='')?`/images/password_failed.svg`:(!passwordCriteria[criteria]["regex"].test(updateData['new_password'])&&updateData.new_password!=='')?'/images/password_not_satisfied.svg':"/images/password_satisfied.svg"} alt="icon" />
                                                            </span>
                                                            {/* text-[#1A883C] */}
                                                            <span className={`text-sm font-normal ${(updateData.new_password.trim()==='')?'text-[#000000]':(!passwordCriteria[criteria]["regex"].test(updateData['new_password'])&&updateData.new_password.trim()!=='')?'text-[#C81720]':'text-[#1A883C]'}  pl-1.5`}>
                                                                {index==4?<>{criteria.split('\n')[0]}<br/>{criteria.split('\n')[1]}</>:criteria}
                                                            </span>
                                                        </li>
                                                    ))}
                                                  
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
                {/* </>} */}
            </div>
        </>
    )
}
